<svg width="80" height="80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M40 6.67A33.37 33.37 0 0 0 6.67 40 33.37 33.37 0 0 0 40 73.33 33.37 33.37 0 0 0 73.33 40 33.37 33.37 0 0 0 40 6.67Zm0 60A26.7 26.7 0 0 1 13.33 40 26.7 26.7 0 0 1 40 13.33 26.7 26.7 0 0 1 66.67 40 26.7 26.7 0 0 1 40 66.67Z"
    fill="#fff"
  />
  <path d="M30 56.67 56.67 40 30 23.33v33.34Z" fill="#fff" />
</svg>
